import { render, staticRenderFns } from "./FabricListingGridView.vue?vue&type=template&id=78c489b6&scoped=true"
import script from "./FabricListingGridView.vue?vue&type=script&lang=js"
export * from "./FabricListingGridView.vue?vue&type=script&lang=js"
import style0 from "./FabricListingGridView.vue?vue&type=style&index=0&id=78c489b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c489b6",
  null
  
)

export default component.exports